import Vue from 'vue'
import VueRouter from 'vue-router'
import { getUserId, getInstitutionAccountId } from '../utils/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: () => {
            if (getInstitutionAccountId()) return '/institution/dashboard'
            if (getUserId()) return '/student/dashboard'
            return '/login'
        },
    },
    {
        path: '/poster',
        name: 'PublicPoster',
        component: () => import('@/views/public/Poster.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/verify',
        name: 'PublicVerify',
        component: () => import('@/views/public/Verify.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/verify/:reportId',
        name: 'PublicVerifyById',
        component: () => import('@/views/public/Verify.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/components/Login'),
        meta: { requiresAuth: false },
    },
    {
        path: '/student',
        component: () => import('@/layouts/StudentLayout.vue'),
        meta: { requiresAuth: true, portal: 'student' },
        children: [
            { path: '', redirect: 'dashboard' },
            { path: 'dashboard', name: 'StudentDashboard', component: () => import('@/views/student/Dashboard.vue') },
            { path: 'catalog', name: 'StudentCatalog', component: () => import('@/views/student/Catalog.vue') },
            { path: 'catalog/:subjectCode', name: 'StudentCatalogSubject', component: () => import('@/views/student/CatalogSubject.vue') },
            { path: 'attempts', name: 'StudentAttempts', component: () => import('@/views/student/Attempts.vue') },
            { path: 'attempts/:subjectCode', name: 'StudentAttemptsSubject', component: () => import('@/views/student/AttemptsSubject.vue') },
            { path: 'pass', name: 'StudentPass', component: () => import('@/views/student/Pass.vue') },
            { path: 'pass/order', name: 'StudentPassOrder', component: () => import('@/views/student/PassOrder.vue') },
            { path: 'transcript/:applicationId', name: 'StudentTranscript', component: () => import('@/views/student/Transcript.vue') },
            { path: 'profile', name: 'StudentProfile', component: () => import('@/views/student/Profile.vue') },
        ],
    },
    {
        path: '/institution',
        component: () => import('@/layouts/InstitutionLayout.vue'),
        meta: { requiresAuth: true, portal: 'institution' },
        children: [
            { path: '', redirect: 'dashboard' },
            { path: 'dashboard', name: 'InstitutionDashboard', component: () => import('@/views/institution/Dashboard.vue') },
            { path: 'catalog', name: 'InstitutionCatalog', component: () => import('@/views/institution/Catalog.vue') },
            { path: 'registrations', name: 'InstitutionRegistrations', component: () => import('@/views/institution/Registrations.vue') },
            { path: 'history', redirect: 'past-quarters' },
            { path: 'past-quarters', name: 'InstitutionPastQuarters', component: () => import('@/views/institution/PastQuarters.vue') },
            { path: 'past-quarters/:subjectCode', name: 'InstitutionPastQuartersSubject', component: () => import('@/views/institution/PastQuarters.vue') },
            { path: 'transcript/:applicationId', name: 'InstitutionTranscript', component: () => import('@/views/student/Transcript.vue') },
        ],
    },
    {
        path: '/pass-pay',
        name: 'StudentPassPay',
        component: () => import('@/views/student/PassPay.vue'),
        meta: { requiresAuth: true, portal: 'student' },
    },
    {
        path: '/ready/exam',
        name: 'ExamReady',
        component: () => import('@/components/Student/ExamReady'),
        meta: { requiresAuth: true },
    },
    {
        path: '/exam',
        name: 'Exam',
        component: () => import('@/components/Student/StudentExam'),
        meta: { requiresAuth: true },
    },
]

const router = new VueRouter({
    linkActiveClass: 'active',
    routes,
})

router.beforeEach((to, from, next) => {
    // Always allow public routes (including /login) so a stuck session can be cleared via Sign out / login page.
    if (to.path === '/login' || to.meta.requiresAuth === false) {
        next()
        return
    }
    if (!to.meta.requiresAuth) {
        next()
        return
    }
    const portal = to.matched.find(r => r.meta.portal)
    const portalType = portal && portal.meta.portal
    if (portalType === 'institution') {
        if (!getInstitutionAccountId()) {
            next({ path: '/login' })
            return
        }
        next()
        return
    }
    if (portalType === 'student') {
        if (!getUserId()) {
            next({ path: '/login' })
            return
        }
        next()
        return
    }
    if (!getUserId() && !getInstitutionAccountId()) {
        next({ path: '/login' })
        return
    }
    next()
})

export default router
